export default __webpack_public_path__ + "static/media/avalanche.e1fb45e8.png";